<template>
  <div class="Vragenlijst">
    <vraag
      v-if="huidigevraag"
      :vraag="huidigevraag.Vraag"
      :antwoordtype="huidigevraag.AntwoordType"
      :image="huidigevraag.Afbeelding"
      :audio="huidigevraag.Audio"
      :autonext="huidigevraag.AutoNext"
      :vraagid="huidigevraag.VraagId"
      :userid="huidigevraag.MedewerkerId"
      :vraagaanwezig="huidigevraag != null"
      v-on:antwoord="antwoord"
      :afbeeldingcode="huidigevraag.AfbeeldingCode"
    />
    <div v-if="huidigevraag == null && !loading" class="eindtekst">
      <h1>Dit was de laatste vraag. Bedankt en misschien tot ziens.</h1>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vraag from "@/components/Vraag.vue";

export default {
  name: "vragenlijst",
  components: {
    Vraag,
  },
  data() {
    return {
      vragen: [],
      huidigevraag: null,
      loading: true,
      vraagidx: 0,
    };
  },
  methods: {
    getVragen: function () {
      this.$api
        .pVragensessieGet({ VragensessieId: this.$route.params.sessie })
        .then((response) => {
          this.vragen = response.data;
          if (this.vragen.length > 0) {
            this.huidigevraag = this.vragen[0];
            this.vraagidx = 0;
            this.loading = false;
          }
        });
    },
    saveAntwoord: function (antwoord) {
      this.$api
        .pAntwoordSave({
          VragensessieId: this.$route.params.sessie,
          VraagId: this.huidigevraag.VraagId,
          UserId: this.huidigevraag.MedewerkerId,
          Antwoord: antwoord,
        })
        .then(() => {});
    },
    antwoord: function (a) {
      switch (a) {
        /* Deze cases komen voor bij beantwoorden via html-buttons */
        case "s1":
          this.saveAntwoord("smiley1");
          break;
        case "s2":
          this.saveAntwoord("smiley2");
          break;
        //case "s3":
        //this.saveAntwoord('Smiley3');
        //break;
        case "s4":
          this.saveAntwoord("smiley3");
          break;
        case "slaover":
          this.saveAntwoord("skip");
          break;
        case "ja":
          this.saveAntwoord("ja");
          break;
        case "nee":
          this.saveAntwoord("nee");
          break;
        /* Deze cases komen voor bij beantwoorden via hardware-buttons */
        case "next":
          // Niets doen, antwoord is al gesaved vanuit de button.
          break;
      }
      // Volgende vraag....
      if (this.vraagidx < this.vragen.length - 1) {
        this.vraagidx++;
        this.huidigevraag = this.vragen[this.vraagidx];
      } else {
        this.huidigevraag = null;
        this.$api.pSessieBeeindig({
          VragensessieId: this.$route.params.sessie,
          ConsoleNaam: "Prototype-001",
        });

        // Na 10 seconde naar het wachtscherm
        setTimeout(function () {
          window.location = "/wacht";
        }, 10000);
      }
    },
    spreekAfsluiting: function () {
      var audio = new Audio("/audio/Afsluiting.mp3");
      audio.play();
    },
  },
  watch: {
    huidigevraag: function () {
      if (this.huidigevraag == null && !this.loading) {
        this.spreekAfsluiting();
      }
    },
  },
  created: function () {
    this.getVragen();
  },
};
</script>

<style scoped>
/* Algemene css, voorheen uit app.vue. Nu alleen voor Vinnie-schermen, de rest is nu Vuetify */
#app {
  font-family: "Trebuchet MS", Arial, sans-serif;
  font-weight: 300;
  color: #2c3e50;
  margin-top: 0px;
}

html {
  overflow-y: scroll;
}

body {
  margin: 0px;
}

.content-div {
  min-height: 500px;
  width: 1260px;
  margin-left: auto;
  margin-right: auto;
}

/* Einde algemene css */

.eindtekst {
  width: 100%;
  height: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>